import { createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "trial-banner"
}
const _hoisted_2 = { class: "trial-text" }
const _hoisted_3 = { class: "content-area" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_main = _resolveComponent("v-main")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createCommentVNode(" ===============================================================\n         GLOBAL HEADER\n         =============================================================== "),
    _createVNode($setup["TheHeader"]),
    _createCommentVNode(" ===============================================================\n         TRIAL BANNER\n         =============================================================== "),
    ($setup.trialDays && $setup.trialDays.maxDays && $setup.showBanner)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_v_icon, { size: "18" }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode(" mdi-information-outline ", -1 /* CACHED */)
            ]))]),
            _: 1 /* STABLE */
          }),
          _createElementVNode("div", _hoisted_2, _toDisplayString($setup.isTrialExpired ? 'Trial Ended' : 'Trial: ' + $setup.trialDays.maxDays + ' left until your trial ends.'), 1 /* TEXT */),
          _createElementVNode("a", {
            href: "#",
            onClick: $setup.navigateToCheckout,
            class: "trial-link"
          }, "BUY NOW"),
          _createVNode(_component_v_icon, {
            size: "16",
            class: "trial-close-icon",
            onClick: $setup.hideBanner
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode(" mdi-close ", -1 /* CACHED */)
            ]))]),
            _: 1 /* STABLE */
          })
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" ===============================================================\n         GLOBAL SPA LOADER\n         =============================================================== "),
    _createVNode(_component_v_overlay, {
      "model-value": $setup.loading,
      class: "spa-loader",
      persistent: "",
      width: "100%",
      height: "100%",
      opacity: "0.25"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, {
          justify: "center",
          align: "center",
          class: "loader-row"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              size: "48",
              width: "4",
              color: "primary"
            })
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["model-value"]),
    _createCommentVNode(" ===============================================================\n         APPLICATION LAYOUT\n         =============================================================== "),
    _createVNode(_component_v_main, { class: "mt-16" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, { "no-gutters": "" }, {
          default: _withCtx(() => [
            _createCommentVNode(" -----------------------------------------------------------\n             LEFT NAVIGATION\n             Rendered only when product menu is available\n        ------------------------------------------------------------ "),
            ($setup.showNavigation)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 0,
                  cols: "auto"
                }, {
                  default: _withCtx(() => [
                    _createVNode($setup["TheUnifiedNavigation"], {
                      class: "mt-16 content-area index",
                      "account-id": $setup.userStore.getAccountId,
                      "nav-blocks": $setup.navigation,
                      enableStoreMenu: $setup.saleNavigation,
                      collapsed: $setup.userStore.isNavigationRail,
                      "onUpdate:collapsed": $setup.toggleLeftMenu
                    }, {
                      "store-control": _withCtx(() => [...(_cache[5] || (_cache[5] = [
                        _createElementVNode("div", { id: "sale-channel-navigation" }, null, -1 /* CACHED */)
                      ]))]),
                      "top-block": _withCtx(() => [
                        _createVNode($setup["OnboardingMenu"])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["account-id", "nav-blocks", "enableStoreMenu", "collapsed"])
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" -----------------------------------------------------------\n             MAIN CONTENT AREA\n        ------------------------------------------------------------ "),
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode($setup["DrawerHost"], { ref: "drawerRef" }, null, 512 /* NEED_PATCH */),
                  _createVNode(_component_router_view)
                ])
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode($setup["AlertModal"], {
          show: $setup.alertModalState.show,
          state: $setup.alertModalItems,
          onConfirm: $setup.handleAlertConfirm,
          onCancel: _cache[0] || (_cache[0] = ($event: any) => ($setup.alertModalService.hide()))
        }, null, 8 /* PROPS */, ["show", "state"]),
        _createVNode(_component_v_dialog, {
          "model-value": $setup.hasPackageUpdate,
          "max-width": "472",
          persistent: ""
        }, {
          default: _withCtx(() => [
            _createVNode($setup["UpdatePage"], { onClose: $setup.handlePackageUpdateClose })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["model-value"]),
        _createVNode($setup["AppSnackbar"], {
          modelValue: $setup.showSnackbar,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.showSnackbar) = $event)),
          type: $setup.snackbarMessage?.type,
          title: $setup.snackbarMessage?.title,
          message: $setup.snackbarMessage?.message,
          timeout: $setup.snackbarMessage?.timeout,
          onClose: _cache[2] || (_cache[2] = ($event: any) => ($setup.shellBridgeStore.setSnackbarMessage({})))
        }, null, 8 /* PROPS */, ["modelValue", "type", "title", "message", "timeout"])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}